import { vinMessage, requiredMessage } from "../validationMessages";
import { vinValidator as vinValidatorRegex } from "../validationRegex";

import { trimmedString } from "./trimmedString";

export const vinValidator = trimmedString.matches(vinValidatorRegex, {
  message: vinMessage,
  excludeEmptyString: true,
});
export const vinValidatorRequired = trimmedString
  .required(requiredMessage)
  .matches(vinValidatorRegex, vinMessage);
